import { useEffect, useState } from 'react';
import * as bd from 'react-basic-design';
import { accountApi } from '../../../api/account-api';
import { apiConfig } from '../../../api/config';
import SvgAddAPhoto from '../../../assets/icons/AddAPhoto';
import { InitFailed } from '../../../components/basic/init-failed';
import { Loading } from '../../../components/basic/loading';
import { T } from '../../../components/basic/text';
import { useQuery } from '../../../components/basic/use-query';
import { BDUpload } from '../../../components/bd/bd-upload';
import { PageNavbar } from '../../../components/ui/page-navbar';
import { useProfileImage } from '../../../hooks/use-profile-image.tsx';
import { TProvider } from '../../../i18n';
import { UserChangePassword } from './user-change-password';
import { UserChangePhoneNumber } from './user-change-phone-number';
import { UserChangeProfile } from './user-change-profile';
import { UserDevicesInfo } from './user-devices-info';
import { UserProfileInfo } from './user-profile-info';

export const UserProfileApp = () => {
    const q = useQuery();

    const [model, setModel] = useState({
        init: false,
        _id: 'view',
        error: null,
    });
    const pic = useProfileImage();

    useEffect(() => {
        if (model.init) return;
        accountApi
            .initUserProfile()
            .then(result => setModel({ ...model, ...result, init: true }))
            .catch(err => setModel({ ...model, error: err }));
    }, [model]);

    if (!model.init) return <Loading />;
    if (model.error instanceof Error)
        return (
            <InitFailed
                ex={model}
                onRetry={() => setModel({ ...model, init: false, error: null })}
            />
        );
    const is_edit_mode = model._id === 'edit-profile';
    const parent_style = { maxWidth: 500 };
    const child_style = { maxWidth: 500, borderRadius: 9 };
    const style = { position: 'relative' };
    const edit_mode_style = { position: 'absolute', bottom: '1rem', left: 100 };
    const image_style = { width: 125, height: 125 };

    const maxImageSize = { width: 800, height: 800 };

    return (
        <TProvider ns="user-profile">
            <div className="container-fluid pb-6" style={parent_style}>
                {model._id !== 'view' && (
                    <PageNavbar
                        title="back"
                        className="small sm pb-0"
                        onGoBack={() => setModel({ ...model, _id: 'view' })}
                    />
                )}

                <bd.Paper className="p-3 mt-3 mx-auto border shadow-3" style={child_style}>
                    <div className="text-center" style={style}>
                        <img
                            src={pic.data}
                            alt="profileImage"
                            className="rounded-circle border bg-default mb-3"
                            style={image_style}
                        />

                        {is_edit_mode && (
                            <div style={edit_mode_style}>
                                <BDUpload
                                    imageOnly
                                    buttonVariant="text"
                                    validType=".png, .jpg, .jpeg"
                                    maxImageSize={maxImageSize}
                                    uploadUrl={`${apiConfig.attachmentUrl}/upload-user-profile-image`}
                                    onUpload={pic.upload}
                                >
                                    <SvgAddAPhoto />
                                    <T className="p-s-1">change</T>
                                </BDUpload>
                            </div>
                        )}
                    </div>

                    <h3>{model.user.userName}</h3>
                    <div className="mb-3">
                        {model.user.firstName} {model.user.lastName}
                    </div>

                    {model._id === 'view' && <UserProfileInfo model={model} setModel={setModel} />}
                    {model._id === 'view-devices' && (
                        <UserDevicesInfo
                            devices={model.devices}
                            onDelete={id =>
                                setModel({
                                    ...model,
                                    devices: model.devices.filter(x => x.id !== id),
                                })
                            }
                        />
                    )}
                    {is_edit_mode && <UserChangeProfile model={model} setModel={setModel} />}
                    {model._id === 'change-password' && (
                        <UserChangePassword model={model} setModel={setModel} />
                    )}
                    {model._id === 'change-phone-number' && (
                        <UserChangePhoneNumber model={model} setModel={setModel} />
                    )}
                </bd.Paper>
            </div>
        </TProvider>
    );
};
